module.exports = __webpack_public_path__ + "static/img/electromagnetic-control-rod_256.daa3e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/electromagnetic-control-rod_256.png
// module id = Mw2B
// module chunks = 0